import { theme } from '@prophecy/theme';
import { Stack } from '@prophecy/ui-v3';

import { ListingHeaderType } from '../config';
import { SearchInput, SelectFooter, SourceSelectBox } from '../Import/steps/utils';
import { TeamsProjects } from './TeamsProjects';

export const ListingHeader = ({
  onChange,
  searchName = '',
  projectName = '',
  source = ''
}: ListingHeaderType & { onChange: (name: keyof ListingHeaderType, value?: string) => void }) => {
  return (
    <Stack gap={theme.spaces.x16} direction='horizontal'>
      <SearchInput value={searchName} onChange={(name) => onChange('searchName', name)} />
      <SourceSelectBox value={source || 'Source System'} onChange={(name) => onChange('source', name)} />
      <TeamsProjects
        hasLabel={false}
        hasLanguageFilter={false}
        footer={projectName ? <SelectFooter onClick={() => onChange('projectName', '')} /> : null}
        value={projectName}
        onChange={(name) => onChange('projectName', name)}
      />
    </Stack>
  );
};
